import { lazy } from 'react';

const BonusDetails = lazy(() => import('./details'));

export { Bonuses } from './list';
export { BonusDetails };
